import { render, staticRenderFns } from "./corporateLoginPage.vue?vue&type=template&id=222bf028&scoped=true&"
import script from "./corporateLoginPage.vue?vue&type=script&lang=js&"
export * from "./corporateLoginPage.vue?vue&type=script&lang=js&"
import style0 from "./corporateLoginPage.vue?vue&type=style&index=0&id=222bf028&prod&lang=scss&"
import style1 from "./corporateLoginPage.vue?vue&type=style&index=1&id=222bf028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222bf028",
  null
  
)

export default component.exports